import { render, staticRenderFns } from "./DrawBoard.vue?vue&type=template&id=2533c5d6&scoped=true"
import script from "./DrawBoard.vue?vue&type=script&lang=js"
export * from "./DrawBoard.vue?vue&type=script&lang=js"
import style0 from "./DrawBoard.vue?vue&type=style&index=0&id=2533c5d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2533c5d6",
  null
  
)

export default component.exports